import { render, staticRenderFns } from "./PurchaseReturnDetail.vue?vue&type=template&id=653b3cc4"
import script from "./PurchaseReturnDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports